import { useQuery, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCustomFilterDetails } from 'modules/_common/api';

export const useQueryCustomFilterDetails = ({
  filterId,
  enabled,
}: {
  filterId: string | null | undefined;
  enabled: boolean;
}) => {
  const queryClient = useQueryClient();

  const query = useQuery(
    [QUERY_KEYS.RESERVATION_NEW_CUSTOM_FILTER_DETAILS, filterId],
    () => getCustomFilterDetails({ filterId }),
    { enabled, cacheTime: 0 },
  );

  const fetchDirectly = async ({ currentFilterId }: { currentFilterId?: string }) => {
    if (!currentFilterId) return;

    return queryClient.fetchQuery(
      [QUERY_KEYS.RESERVATION_NEW_CUSTOM_FILTER_DETAILS, currentFilterId],
      () => getCustomFilterDetails({ filterId: currentFilterId }),
      { cacheTime: 0 },
    );
  };

  return { ...query, fetchDirectly };
};
